export const VideoLibraryBreakpoints = {
  small: 500, // Below this, use SMALL styling
  w360: 360,
  chrome: 350,
  xsmall: 325, // Below this, use override styles for LabelsMenu buttons and dropdown
  mobile: 282,
} as const;
